import PropTypes from 'prop-types'

import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'

const CardsCarouselNavButton = ({icon: IconComponent, ...props}) => (
  <Button
    type="button"
    intent={BUTTON_INTENTS.PRIMARY}
    shape={BUTTON_SHAPES.CIRCLE}
    size={BUTTON_SIZES.MEDIUM}
    variant={BUTTON_VARIANTS.OUTLINE}
    {...props}
  >
    <Icon size={ICON_SIZES.MD}>
      <IconComponent size={ICON_SIZES.MD} />
    </Icon>
  </Button>
)

CardsCarouselNavButton.displayName = 'CardsCarouselNavButton'

CardsCarouselNavButton.propTypes = {
  icon: PropTypes.elementType.isRequired
}

export default CardsCarouselNavButton
